import { CreateTimeFrameBulkInput, CreateTimeFrameBulkResponse, CreateTimeFrameInput, TimeFrame } from '@/models/gen/graphql';

import { CreateTimeFrameBulkDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import { Validation } from '@/utils';
import graphApi from '@/api';

type CreateTimeFrameBulkGraphApiResponse = GraphApiResponse<typeof CreateTimeFrameBulkDocument>;

export const createTimeFrameValidator = new Validation.Validator({
  'name!': (val: any): Validation.Validity => ({
    valid: !!val && new RegExp('^[^ ][0-9a-z ]', 'i').test(val),
  }),
});

const createTimeFrameBulkResponseSelector = (res: CreateTimeFrameBulkGraphApiResponse): CreateTimeFrameBulkResponse =>
  !res.errors ? (res?.createTimeFrameBulk as CreateTimeFrameBulkResponse) : undefined;

const [runCreateTimeFrameBulk] = graphApi(CreateTimeFrameBulkDocument);

const createTimeFrameBulk = async (timeFrames: Partial<TimeFrame>[]): Promise<CreateTimeFrameBulkResponse> => {
  const values: CreateTimeFrameInput[] = timeFrames.map(
    (timeFrame: TimeFrame): CreateTimeFrameInput => createTimeFrameValidator.create(timeFrame)
  );
  const input: CreateTimeFrameBulkInput = { values };

  const res = await runCreateTimeFrameBulk({ input });
  return createTimeFrameBulkResponseSelector(res);
};

export default createTimeFrameBulk;
